export const imageMimeTypes = ['image/jpeg', 'image/png'];
export const fileAttachmentMimeTypes = [
  ...imageMimeTypes,
  'application/octet-stream',
  'application/doc',
  'application/json',
  'application/mspowerpoint',
  'application/msword',
  'application/pdf',
  'application/rtf',
  'application/vnd.ms-excel',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
  'application/vnd.openxmlformats-officedocument.presentationml.template',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/xml',
  'application/x-rtf',
  'image/bmp',
  'image/gif',
  'image/jpg',
  'image/tif',
  'image/tiff',
  'text/csv',
  'text/plain',
  'text/richtext',
  'text/rtf',
  'text/tab-separated-values',
];
